import { Dispatch, SetStateAction } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { Button } from 'src/components/ui/button'
import { DialogClose } from 'src/components/ui/dialog'
import { IOrder } from 'src/_models/order.model'
import OrderDocumentStatus from 'src/components/order/document-status'
import OrderSignatureGuaranteeView from 'src/components/order/signature-guarantee-view'
import TotalPayableAmount from 'src/components/order/total-payable-amount'

const SupplierOrderDeliveryConfirmation = ({ order, goNext }: { order: IOrder; goNext: () => void }) => {
  return (
    <>
      <div className="flex max-h-[calc(90vh-514px)] flex-col overflow-y-scroll px-[30px]">
        <OrderDocumentStatus order={order} />
        <OrderSignatureGuaranteeView
          order={order}
          type="SUPPLIER_DELIVERY_CONFIRMATION"
          title="Delivery Confirmation Signature"
          description="Buyer will sign here once order is delivered and they have received the delivery."
          orderGuaranteeText={order.supplierDeliveryConfirmationText}
          orderGuaranteeMediaKey={order.supplierDeliveryConfirmationMedia?.fileKey}
        />
        <OrderSignatureGuaranteeView
          order={order}
          type="SUPPLIER_PRODUCT_CONFIRMATION"
          title="Product Confirmation Signature"
          description="Buyer will sign here once product has been verified."
          orderGuaranteeText={order.supplierProductConfirmationText}
          orderGuaranteeMediaKey={order.supplierProductConfirmationMedia?.fileKey}
        />
      </div>
      <div className="mt-5 h-[136px] px-[30px]">
        <hr className=" mt-[10px] h-px border-0 bg-[#E0E0E0]" />
        <TotalPayableAmount order={order} />
        <div className="flex gap-5">
          <DialogClose asChild>
            <Button variant="secondary">Cancel</Button>
          </DialogClose>
          <Button disabled>Guarantee Order</Button>
        </div>
      </div>
    </>
  )
}

export default SupplierOrderDeliveryConfirmation
